package one.healthium.insights.ui.utils

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import one.healthium.insights.domain.models.ColorModel
import one.healthium.insights.domain.models.ThemeColor
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun ColorModel.resolve(): Color {
    return when (this) {
        is ColorModel.Hex -> Color(color)
        is ColorModel.Theme -> when (color) {
            ThemeColor.Primary -> AppTheme.colors.primary
            ThemeColor.Secondary -> AppTheme.colors.secondary
        }
    }
}